import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://emolxlilpzyypcrfurlm.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVtb2x4bGlscHp5eXBjcmZ1cmxtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODIyNjM1MDEsImV4cCI6MjA5NzgzOTUwMX0.N11meGrbI5yAns0W449yM2sMBxKUtYQP2qXu1B28OJ8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
